import "../stylesheets/App.css";
import "../stylesheets/Rules.css";
import React, { useEffect } from "react";
import Header from "./subcomponents/Header.js";

function PrivacyPolicy() {
  useEffect(() => {
    const el = document.getElementById("search-container");
    if (el) el.style.display = "none";
  }, []);
  return (
    <>
      <Header />
      <section className="rules-container">
        <h1 className="rules-title">TÉRMINOS Y CONDICIONES</h1>
        <h2 className="rules-title">Quiniela HMQ - Mundial de Fútbol</h2>
        <div className="rules-div">
          <h2 className="rules-subtitle">1. Organización</h2>
          <p className="rules-text">La presente Quiniela (en adelante, la "Quiniela") es organizada por HMQ (en adelante, el "Organizador"). La participación en la Quiniela implica la aceptación plena y sin reservas de los presentes Términos y Condiciones.</p>
          <h2 className="rules-subtitle">2. Participación</h2>
          <p className="rules-text">Podrán participar únicamente clientes de HMQ que completen correctamente el formulario de inscripción, cuenten con un número de cliente HMQ válido y acepten los presentes Términos y Condiciones.</p>
          <p className="rules-text">Cada participante deberá proporcionar información verídica y actualizada. HMQ se reserva el derecho de verificar la validez de los datos suministrados y de descalificar cualquier participación que contenga información falsa, incompleta o incorrecta.</p>
          <p className="rules-text">La participación es gratuita y se permite una única inscripción por persona.</p>
          <h2 className="rules-subtitle">3. Mecánica de la Quiniela</h2>
          <p className="rules-text">La Quiniela consiste en realizar pronósticos de los resultados de los partidos del Mundial de Fútbol mediante la plataforma habilitada por HMQ.</p>
          <p className="rules-text">Los participantes acumularán puntos según la exactitud de sus pronósticos, de acuerdo con las reglas de puntuación establecidas dentro de la plataforma.</p>
          <p className="rules-text">Los pronósticos deberán realizarse antes del inicio de cada partido. Una vez iniciado un encuentro, no será posible modificar las predicciones correspondientes.</p>


          <h2 className="rules-subtitle">4. Premios</h2>
          <p className="rules-text">Los participantes con mayor puntuación al finalizar el Mundial serán considerados ganadores de acuerdo con la clasificación final de la Quiniela.</p>
          <p className="rules-text">Los premios serán comunicados oportunamente por HMQ.</p>
          <p className="rules-text">Los premios no son transferibles ni canjeables por dinero y no incluyen gastos adicionales no especificados por el Organizador.</p>
          <p className="rules-text">Al finalizar la Quiniela, HMQ validará la información registrada por los ganadores para verificar que el número de cliente proporcionado corresponda a un cliente real y activo. En caso de detectarse información falsa, incorrecta o un número de cliente inválido, el participante perderá el derecho al premio y será descalificado, pudiendo asignarse el premio al siguiente participante elegible según la clasificación final.</p>

          <h2 className="rules-subtitle">5. Recolección y uso de datos personales</h2>
          <p className="rules-text">Para participar en la Quiniela, el usuario deberá proporcionar la siguiente información:</p>

          <ul className="rules-text">
            <li>Nombre completo</li>
            <li>Correo electrónico</li>
            <li>Número de cédula</li>
            <li>Número de cliente HMQ</li>
          </ul>


          <p className="rules-text">Esta información será utilizada para:</p>

          <ul className="rules-text">
            <li>Gestionar la participación en la Quiniela</li>
            <li>Verificar la identidad y elegibilidad de los participantes</li>
            <li>Contactar a los participantes y ganadores.</li>
            <li>Coordinar la entrega de premios.</li>
            <li>Comunicar promociones, beneficios, novedades, campañas e información relevante relacionada con los productos y servicios de HMQ.</li>
          </ul>

          <p className="rules-text">HMQ se compromete a utilizar la información recopilada únicamente para los fines relacionados con la presente dinámica y de conformidad con la normativa aplicable.</p>

          <h2 className="rules-subtitle">6. Responsabilidad</h2>

          <p className="rules-text">El Organizador no será responsable por:</p>

          <ul className="rules-text">
            <li>Errores en los datos suministrados por los participantes</li>
            <li>Problemas técnicos, fallas de conexión o indisponibilidad temporal de la plataforma.</li>
            <li>Situaciones de fuerza mayor que afecten el desarrollo normal de la Quiniela.</li>
          </ul>

           <h2 className="rules-subtitle">7. Modificaciones</h2>

        <p className="rules-text">HMQ se reserva el derecho de modificar estos Términos y Condiciones, así como cualquier aspecto operativo de la Quiniela, cuando las circunstancias lo requieran. Cualquier modificación será comunicada a los participantes a través de los canales oficiales de comunicación.</p>

        <h2 className="rules-subtitle">8. Aceptación</h2>

        <p className="rules-text">La participación en la Quiniela implica la aceptación expresa de estos Términos y Condiciones, así como de las decisiones que adopte HMQ respecto a cualquier situación no contemplada en el presente documento.</p>

        <h2 className="rules-subtitle">9. Vigencia</h2>

        <p className="rules-text">La Quiniela tendrá vigencia durante el período oficial del Mundial de Fútbol y concluirá una vez finalizado el torneo, realizada la validación de los ganadores y entregados los premios correspondientes.</p>

        </div>

       
      </section>
    </>
  );
}

export default PrivacyPolicy;
